import React from 'react';
import { Link } from '@fluentui/react-components';

export const STEPS = {
  OPTIONS_STEP: 'OPTIONS_STEP',
  AGREE_STEP: 'AGREE_STEP',
  DISAGREE_STEP: 'DISAGREE_STEP',
  DONE_STEP: 'DONE_STEP',
};

export const DECISIONS = {
  CONTACT_AGENT: 'ContactAgent',
  RECEIVE_EMAIL: 'ReceiveEmail',
  ACK_CHANGE: 'AckChange',
  DENY_CHANGE: 'DenyChange',
};

export const STEPS_CONFIG = {
  [STEPS.OPTIONS_STEP]: {
    title: _TL_('Adopt Consent Mode for UET by May 5, 2025'),
    description: _TL_('Ensure proper consent transmission for users visiting from the European Economic Area (EEA), the United Kingdom, and Switzerland by implementing {{a}}Consent Mode{{/a}} with your UET tags to avoid any negative impact on conversion attribution and remarketing segments by May 5, 2025. Learn more: {{b}}FAQ: UET and user consent{{/b}}.'),
    radioList: [
      { value: 'agree', label: _TL_('We will enable Consent Mode by May 5, 2025') },
      { value: 'disagree', label: _TL_('We will not enable Consent Mode by May 5, 2025') },
    ],
    templateModel: {
      a: text => <Link href="https://help.ads.microsoft.com/#apex/ads/en/60119/1" target="_blank">{text}</Link>,
      b: text => <Link href="https://help.ads.microsoft.com/#apex/ads/en/60341/1" target="_blank">{text}</Link>,
    },
  },
  [STEPS.AGREE_STEP]: {
    title: _TL_('Get Assistance to set up Consent Mode'),
    description: _TL_('Please select your preferred method for setting up Consent Mode and implement it by May 5 to continue using conversion-based bid strategies. If Consent Mode isn\'t implemented, Microsoft Advertising may adjust your bid strategy. '),
    radioList: [
      { value: 'agent', label: _TL_('Connect with an agent for setup assistance') },
      { value: 'email', label: _TL_('Receive setup instructions via email') },
    ],
  },
  [STEPS.DISAGREE_STEP]: {
    title: _TL_('Ensure Consent Mode compliance'),
    description: _TL_('After May 5, if you use UET without Consent Mode or TCF, Microsoft Advertising will stop tracking conversions and populating remarketing lists. This will affect campaign performance and UET-based features. To ensure your campaigns continue to perform effectively, please comply with Consent Mode requirements by May 5.'),
    radioList: [
      { value: 'accept', label: _TL_('Microsoft Advertising may update my bid strategy for affected campaigns') },
      { value: 'reject', label: _TL_('Microsoft Advertising won\'t change my bid strategy. I understand this can affect my campaign performance') },
    ],
  },
  [STEPS.DONE_STEP]: {
    title: _TL_('Thank you for confirming your choice'),
    description: {
      [DECISIONS.CONTACT_AGENT]: _TL_('A support member will be in touch with you shortly via Copilot chat. If you need to change your selection, please contact {{a}}Microsoft Advertising support{{/a}}. '),
      [DECISIONS.RECEIVE_EMAIL]: _TL_('We\'ve sent the instructions to your email. Please check your inbox for the details. If you need to change your selection, please contact {{a}}Microsoft Advertising support{{/a}}. '),
      [DECISIONS.ACK_CHANGE]: _TL_('Microsoft Advertising may update your bid strategy by May 5. We will send an email with details before making any changes. If you need to change your selection, please contact {{a}}Microsoft Advertising support{{/a}}.'),
      [DECISIONS.DENY_CHANGE]: _TL_('Microsoft Advertising won\'t update your bid strategy. If you need to change your selection, please contact {{a}}Microsoft Advertising support{{/a}}.'),
    },
    templateModel: {
      a: text => <Link href="https://about.ads.microsoft.com/en/support" target="_blank">{text}</Link>,
    },
  },
};

// TODO: Check-in the strings first to kickoff translation. Need to remove when replace it with the contnets
export const NEW_STRINGS = {
  [STEPS.DISAGREE_STEP]: {
    title: _TL_('Are you sure you don\'t want to setup consent signals?'),
    description: _TL_('After May 5, if you use UET without Consent Mode or TCF, Microsoft Advertising will stop tracking conversions and populating remarketing lists. This will affect campaign performance and UET-based features. To ensure your campaigns continue to perform effectively, please comply with Consent Mode requirements by May 5. If you choose not to implement consent signals, Microsoft Advertising may adjust your bid strategy for affected campaigns to help maintain and optimize performance.'),
  },
};

export const OPTIONS_DECISIONS_MAP = {
  email: DECISIONS.RECEIVE_EMAIL,
  agent: DECISIONS.CONTACT_AGENT,
  accept: DECISIONS.ACK_CHANGE,
  reject: DECISIONS.DENY_CHANGE,
};


export const instrumentationSchema = {
  scenario: [
    {
      name: 'consentModeEnforcementDialog',
      value: 'ConsentModeEnforcementDialog',
      setting: {},
      activity: [
        {
          name: 'dialogActivity',
          value: 'DialogActivity',
        },
      ],
    },
  ],
};
